import { useState } from 'react';
import config from '../../utils/apiUrl';
import useTokenEpayco from './useTokenEpayco';

const useEpaycoCardTransaction = () => {
  const { getTokenApify } = useTokenEpayco();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [transactionData, setTransactionData] = useState(null);

  const processTransaction = async (paymentData) => {
    setLoading(true);
    setError(null);

    try {
      const tokenApify = await getTokenApify();
      const body = JSON.stringify({
        value: String(paymentData.amount),
        docType: paymentData.documentType,
        docNumber: paymentData.documentNumber,
        name: paymentData.firstName,
        lastName: paymentData.lastName,
        email: paymentData.email,
        cellPhone: paymentData.phone,
        phone: paymentData.phone,
        cardNumber: paymentData.cardNumber,
        cardExpYear: '20' + paymentData.expiryDate.slice(-2),
        cardExpMonth: paymentData.expiryDate.slice(0, 2),
        cardCvc: paymentData.cvc,
        currency: 'COP',
        bill: paymentData.bill || 'OR-1234',
        description: paymentData.description || 'Pago de prueba',
        tax: parseFloat(paymentData.tax) || 0,
        tax_base: parseFloat(paymentData.tax_base) || '0',
        dues: paymentData.dues || '1',
        extra1: paymentData.extra1 || '',
        extra2: paymentData.extra2 || '',
        testMode: config.epayco.mode === 'TEST',
        company: paymentData.company || 'titan',
        redirect_url: paymentData.redirect_url,
      });

      const response = await fetch(`${config.epayco.apiUrl}/payment/process`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${tokenApify}`,
          'Content-Type': 'application/json',
        },
        body,
      });

      const result = await response.json();

      if (response.ok) {
        setTransactionData(result.data?.transaction?.data || null);
        return result; // Devuelve toda la respuesta, incluyendo success y posibles errores
      } else {
        console.error(
          'Error en la transacción:',
          result.message || 'Error desconocido'
        );
        return result; // Devuelve la respuesta con el error
      }
    } catch (error) {
      console.error('Error al procesar la transacción:', error.message);
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  return {
    processTransaction,
    loading,
    error,
    transactionData,
  };
};

export default useEpaycoCardTransaction;
